import axios from 'axios';

export default {
    getClientToken(cb, { clientId, clientSecret }) {
        axios
            .post('/api/ClientToken', { clientId, clientSecret }, { headers: { 'Content-Type': 'application/json' } })
            .then(response => response.data)
            .then(data => {
                cb(data);
            })
            .catch(err => cb(err.response));
    },
    getSearchResults(cb, { Longitude, Latitude, SearchRadius, City, State, ZipCode, ExcludeMilesAway, ClinicId, PageSize, PageNumber, dealerId, clientToken }) {
        axios
            .get('/api/Clinic', {
                params: {
                    Longitude,
                    Latitude,
                    SearchRadius,
                    City,
                    State,
                    ZipCode,
                    ExcludeMilesAway,
                    ClinicId,
                    PageSize,
                    PageNumber
                },
                headers: {
                    Authorization: `Bearer ${clientToken}`,
                    Dealer: dealerId
                }
            })
            .then(response => response.data)
            .then(data => {
                cb(data);
            })
            .catch(err => cb(err.response));
    },
};
